// removed by extract-text-webpack-plugin
module.exports = {"banner":"banner___ziO1n","banner-inner":"banner-inner___1uq8H","submit":"submit___3-K4c","text":"text___3NQdc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfServiceBanner/TermsOfServiceBanner.scss
// module id = VPQH
// module chunks = 60